export const editIconModal = {
  extend: '/add-icon-modal',
  ModalHeader: {
    title: 'Icon Preview',
    p: null,
  },
  Flex: {},
  ModalFooter: {
    'IconButton.trash': {
      icon: 'trash outline',
      onClick: (ev, el, s) => {
            const {
              iconName
            } = s
            const text = 'Do you want to remove the icon?'

            if (iconName && window.confirm(text)) {
              const icons = el.getDesignSystem('icons')
              delete icons[iconName]
              el.updateDesignSystem({
                icons
              })
              el.context.closeModal(el, s)
            }
          },
    },
  },
  on: {
    init: (el, s) => {
          const path = window.location.pathname
          const iconName = path.split('edit-icon/')[1]
          const icons = el.getDesignSystem('icons')
          if (!iconName) return
          const DEFAULT_ICONS = el.getRootState().DEFAULT_ICONS
          const iconInLib = (icons || DEFAULT_ICONS)[iconName] || DEFAULT_ICONS[iconName]
          if (!iconName || !iconInLib) return

          s.update({
            iconName,
            src: iconInLib
          }, {
            preventUpdate: true
          })
        },
    submit: (e, el, s) => {
          e.preventDefault()
        },
  },
};